import { Component, Input } from '@angular/core';

import { Blog } from '@model/entities/blog';
import { appConfig } from '@configuration/app-config';
import { ScrollService } from '@service/scroll.service';
import { UserService } from '@service/user/user.service';
import { MobileService } from '@service/mobile.service';
import { HelperService } from '@service/helper.service';

import { ProfileTypeIdentifier } from '@enum/profile-type-identifier';
import { EntityDisplayComponent } from '@component/entity-display-component';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { StateService } from '@service/state.service';

@Component({
  selector: 'app-blog-display',
  templateUrl: './blog-display.component.html',
  styleUrls: ['./blog-display.component.scss'],
})
export class BlogDisplayComponent extends EntityDisplayComponent {
  protected entityTypeIdentifier: EntityTypeIdentifier = 'blog';

  public ProfileTypeIdentifier = ProfileTypeIdentifier;

  public appConfig = appConfig;

  // disables like / share etc.
  @Input()
  public live: boolean = true;

  public set entity(entity: Blog) {
    this._entity = entity;
    this.computeAuthor();
  }
  public get entity() {
    return this._entity;
  }
  private _entity: Blog = null;

  constructor(
    private ScrollService: ScrollService,
    public UserService: UserService,
    public mobileService: MobileService,
    public helperService: HelperService,
    public EntityTypeConfigService: EntityTypeConfigService,
    public StateService: StateService,
  ) {
    super(EntityTypeConfigService, UserService);
  }

  public edit() {
    this.StateService.goto('/blog/edit/' + this.entity.id).then(() => {
      this.ScrollService.scrollToTop();
    });
  }
}
